import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/components/sections/ClientSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/components/sections/ServiceDetailHero.tsx");
